import React from "react";
import BaseModal from "../BaseModal";
import raccoons from "./raccoons.gif";

function GameWonModal({ open }) {
  return (
    <BaseModal
      title="You won Jennections!"
      initiallyOpen={open}
      showActionButton={false}
    >
      <div className="justify-center">
        {/* the whitespace: pre style makes the emoji grid appear with new lines character */}
        <img
          src={raccoons}
          title="I wonder if there's hidden information in this file..."
        />
      </div>
    </BaseModal>
  );
}

export default GameWonModal;
